module.exports = __webpack_public_path__ + "img/1.9407bce0.jpg";